// extracted by mini-css-extract-plugin
module.exports = {"modal":"confirmModal_modal__2Mi3R","actions":"confirmModal_actions__3LIS2","cancel":"confirmModal_cancel__2mrg2"};